import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'pulse-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input() label = '';
  @Input() color = 'primary';
  @Input() disabled: boolean;
  @Input() type = 'button';

  constructor() {}

  ngOnInit(): void {}
}
